import "./App.css";
import Route from "./route";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap/dist/js/bootstrap.bundle";
import "@fontsource/plus-jakarta-sans";
import CacheBuster from "react-cache-buster";
import OfflineNotifier from "./Pages/OfflineNotification";
import pjson from "../package.json";
import Loading from "./loading";
import { PrimeReactProvider } from "primereact/api";

import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

function App() {
  const isProduction = process.env.NODE_ENV === "production";
  return (
    <CacheBuster
      currentVersion={pjson}
      isEnabled={isProduction} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
    >
      <PrimeReactProvider>
        <OfflineNotifier />
        <Route />
      </PrimeReactProvider>
    </CacheBuster>
  );
}

export default App;
